import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = {
  type: "submit",
  class: "hidden"
}

import { ref } from 'vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import useSearch from '@/shared/search/useSearch';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchField',
  setup(__props) {

const globalLabels = useGlobalLabels(GlobalLabels.search);
const { term, search, goToSearchPage } = useSearch();
const searchModel = ref('');
searchModel.value = term.value;

const input = (): void => {
    search(searchModel.value);
};

const submit = (): void => {
    goToSearchPage();
};


return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "flex items-start flex-nowrap mx-auto pt-10 md:w-1/3",
      action: ".",
      onSubmit: _withModifiers(submit, ["prevent"])
    }, [
      _createVNode(_component_InputText, {
        modelValue: searchModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchModel).value = $event)),
        name: "searchField",
        label: _unref(globalLabels).searchFieldPlaceholder,
        "input-clear": true,
        autofocus: true,
        role: 'combobox',
        "aria-controls": 'live-search-result',
        type: "search",
        "show-errors": false,
        class: "flex-1 o-text-h4 mt-x2 lg:mt-0",
        onInput: input,
        onClear: input
      }, null, 8, ["modelValue", "label"]),
      _createElementVNode("button", _hoisted_3, _toDisplayString(_unref(globalLabels).searchSubmit), 1)
    ], 40, _hoisted_2)
  ]))
}
}

})